import { selectAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { variantFilled, variantFlushed, variantOutlined } from '../../focusShim';
const {
  definePartsStyle,
  defineMultiStyleConfig
} = createMultiStyleConfigHelpers(selectAnatomy.keys);
const pill = definePartsStyle(props => {
  const {
    field
  } = props.theme.components.Select.variants.filled(props);
  return {
    field: Object.assign({}, field, {
      borderRadius: 'full',
      fontWeight: 'semibold',
      _focus: variantFilled()
    })
  };
});
const outline = definePartsStyle(() => {
  return {
    field: Object.assign({
      fontSize: 'sm'
    }, variantOutlined(), {
      backgroundColor: 'GREYSCALE.SUPERNOVA'
    }),
    icon: {
      color: 'CARNABY.regular'
    }
  };
});

// Consider removing this, it's not used.
const flushed = definePartsStyle(() => {
  return {
    field: {
      _focus: variantFlushed()
    }
  };
});
export const selectTheme = defineMultiStyleConfig({
  variants: {
    pill,
    outline,
    flushed
  }
});